import { ErrorState, ErrorAction, DfdError } from './types';
import { SET_DFD_ERROR, DISMISS_ERROR } from './actions';

export const initialState: ErrorState = {
  errors: []
};

export default function errorReducer(state = initialState, action: ErrorAction) {
  switch (action.type) {
    case SET_DFD_ERROR: {
      let existing = null;
      // Do not add duplicate errors
      if (action && action.error) {
        existing = state.errors.find((err: DfdError) => err.message === action.error.message);
      }
      if (!existing) {
        return { ...state, errors: state.errors.concat(action.error as DfdError) };
      }
      return state;
    }
    case DISMISS_ERROR:
      return { ...state, errors: state.errors.filter((err: DfdError) => err.id !== action.id) };
    default:
      return state;
  }
}
